import { render } from "./AboutContainerVue.vue?vue&type=template&id=f39110de"
const script = {}

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\centre-sante-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__